import { Typography } from "@mui/material";

const FormLabel = (props) => (
  // for form labels
  <Typography
    variant="subtitle2"
    sx={{ marginBottom: "5px", ...props.sx }}
  >
    {props.title}
    {props.required && (
      <span style={{ color: "#d32f2f", marginLeft: "3px" }}>*</span>
    )}
    {props.hint && (
      <span style={{ color: "#888", fontWeight: 400, fontSize: "0.75rem", marginLeft: "6px" }}>
        ({props.hint})
      </span>
    )}
  </Typography>
);

export default FormLabel;
